import React from "react"

import "./Cart.scss"

const Cart = () => {
  return (
    <svg
      viewBox="0 0 19 15"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      id="cart-icon"
      className="header-icon-body"
    >
      <title>Vector</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-1341.000000, -36.000000)"
          className="header-icon"
          fillRule="nonzero"
        >
          <g transform="translate(1267.000000, 36.000000)">
            <path d="M79.1025097,0 L75.0144154,0 C74.4564869,0 74,0.45793758 74,1.01763909 C74,1.57734061 74.4564869,2.03527819 75.0144154,2.03527819 L77.560598,2.03527819 L80.5226909,12.6187244 L81.2023493,12.6187244 C80.9791779,12.8731341 80.8371596,13.1987792 80.8371596,13.5753057 C80.8371596,14.3588877 81.4762419,15 82.2573417,15 C83.0384416,15 83.6775229,14.3588877 83.6775229,13.5753057 C83.6775229,13.2089556 83.5355051,12.8731341 83.3123337,12.6187244 L87.4511485,12.6187244 C87.2279771,12.8731341 87.0859583,13.1987792 87.0859583,13.5753057 C87.0859583,14.3588877 87.7250406,15 88.5061404,15 C89.2872403,15 89.9263216,14.3588877 89.9263216,13.5753057 C89.9263216,13.2089556 89.7843038,12.8731341 89.5611324,12.6187244 L89.6422856,12.6187244 C90.200214,12.6187244 90.656701,12.1607868 90.656701,11.6010853 C90.656701,11.0413838 90.200214,10.5834462 89.6422856,10.5834462 L82.0544583,10.5834462 L81.851575,9.85074673 L89.8350241,9.85074673 C90.5248265,9.85074673 91.1233327,9.38263289 91.275495,8.71099106 L93,2.57462688 L79.8227442,2.57462688 L79.8227442,2.57462688 L79.1025097,0 Z"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Cart
